import { WuiThemeSection } from '@jwplayer/wui-react';
import { motion } from 'framer-motion';

import { useMeasure } from '/module/dom-utils';

import css from './style.module.scss';

const Animated = ({ children }: { children: React.ReactNode }) => {
  const [ref, { height }] = useMeasure<HTMLDivElement>();

  return (
    <motion.div
      initial={{ height: '0', overflow: 'hidden' }}
      animate={{ height, overflow: 'initial' }}
      transition={{ duration: 0.4, ease: 'anticipate' }}
    >
      <div ref={ref} className={css.content}>
        {children}
      </div>
    </motion.div>
  );
};

export function FullscreenCard({
  children,
  padded,
  animated,
}: {
  children: React.ReactNode;
  padded?: boolean;
  animated?: boolean;
}) {
  padded = typeof padded === 'undefined' ? true : padded;
  animated = typeof animated === 'undefined' ? true : padded;

  return (
    <div className={css.card}>
      <WuiThemeSection
        theme="light"
        box={{
          padding: padded ? '2xl' : undefined,
        }}
      >
        {animated ? <Animated>{children}</Animated> : <div className={css.content}>{children}</div>}
      </WuiThemeSection>
    </div>
  );
}
